// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentFormComponent } from './document-form.component';

@NgModule({
    declarations: [DocumentFormComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class DocumentFormModule {}
